import { render, staticRenderFns } from "./TabelaServicoAdicional.vue?vue&type=template&id=42925b9e&"
import script from "./TabelaServicoAdicional.vue?vue&type=script&lang=js&"
export * from "./TabelaServicoAdicional.vue?vue&type=script&lang=js&"
import style0 from "./TabelaServicoAdicional.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports